<template>
  <div class="invoicerow"> 
    <div class="column email">
      <mail-icon size="1.5x" class="custom-class"></mail-icon>
      <p class="user">{{ email }}</p>
    </div>
    <div v-if="!isMobile()" class="column bonus">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1.95-9H15v2h-4.95a2.5 2.5 0 0 0 4.064 1.41l1.7 1.133A4.5 4.5 0 0 1 8.028 13H7v-2h1.027a4.5 4.5 0 0 1 7.788-2.543L14.114 9.59A2.5 2.5 0 0 0 10.05 11z" fill="rgba(0,64,255,1)"/></svg>
      <p class="money">{{ (bonus/100).toFixed(2) }}€</p>
    </div>
    <div v-if="!isMobile()" class="column creacion">
      <calendar-icon size="1.5x" class="custom-class"></calendar-icon>
      <p class="money">{{ humanTime(ctime) }}</p>
    </div>
    <div v-if="isMobile()" class="column info">
      <button @click="isShow = true" :aria-label="$t('buttons.moreInformation')" :title="$t('buttons.moreInformation')" class="action" id="info-button">
        <info-icon size="1.5x" class="custom-class"></info-icon>
      </button>
      <div class="information" :style="infoStyle">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
          <h3>{{ $t('dealers.referredUserInformation') }}</h3>
          <x-icon @click="isShow = false" size="1.5x" class="custom-class"></x-icon>
        </div>
        <div class="column email">
          <mail-icon size="1.5x" class="custom-class"></mail-icon>
          <p class="user">{{ email }}</p>
        </div>
        <div class="column bonus">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1.95-9H15v2h-4.95a2.5 2.5 0 0 0 4.064 1.41l1.7 1.133A4.5 4.5 0 0 1 8.028 13H7v-2h1.027a4.5 4.5 0 0 1 7.788-2.543L14.114 9.59A2.5 2.5 0 0 0 10.05 11z" fill="rgba(0,64,255,1)"/></svg>
          <p class="money">{{ (bonus/100).toFixed(2) }}€</p>
        </div>
        <div class="column creacion">
          <calendar-icon size="1.5x" class="custom-class"></calendar-icon>
          <p class="money">{{ humanTime(ctime) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { InfoIcon, CalendarIcon, XIcon, MailIcon } from 'vue-feather-icons';
import moment from 'moment';

export default {
  name: 'referred-users',
  components: {
    InfoIcon,
    CalendarIcon,
    XIcon, 
    MailIcon
  },
  data: function () {
    return {
      isShow: false
    };
  },
  props: ['email', 'ctime', 'bonus'],
  computed: {
    infoStyle () {
      if (this.isShow) {
        return {display: 'block'};
      } else {
        return {display: 'none'};
      }
    },
  },
  methods: {
    isMobile: function () {
      return window.innerWidth <= 450;
    },
    humanTime: function (time) {
      if (time === 0) {
        return '-';
      } else {
        return moment(time * 1000).format('DD/MM/YYYY');
      }
    },
  }
};
</script>